import { API_FEEDBACK_SUBJECTS_PREFIX } from '@shared/config/api/api-prefixes';
import { feedbackBaseApi } from './base';
import { FeedbackSubjectListDataRequest, FeedbackSubjectListDataResponse } from './feedback-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { isEqualParameters } from '@shared/lib/utils/is-equal-parameters/is-equal-parameters';

export const feedbackApi = feedbackBaseApi.injectEndpoints({
    endpoints: (build) => ({
        feedbackSubjectsList: build.query<FeedbackSubjectListDataResponse, FeedbackSubjectListDataRequest>({
            query: (data) => `${API_FEEDBACK_SUBJECTS_PREFIX}${queryParametersToString({ ...data })}`,
            providesTags: ['FeedbackSubjectsList'],
        }),
        feedbackSubjectsInfinityList: build.query<FeedbackSubjectListDataResponse, FeedbackSubjectListDataRequest>({
            query: (parameters) => `${API_FEEDBACK_SUBJECTS_PREFIX}${queryParametersToString({ ...parameters })}`,
            serializeQueryArgs: (params) => {
                return `${params.endpointName}_${params.queryArgs.search}`;
            },
            merge: (cacheResponse, response) => {
                if (response.skip) {
                    cacheResponse.items.push(...response.items);
                }
            },
            forceRefetch({ currentArg, previousArg }) {
                return !isEqualParameters({ currentParameters: currentArg, previousParameters: previousArg });
            },
        }),
    }),
});

export const { useFeedbackSubjectsInfinityListQuery } = feedbackApi;
